import { render } from "./Map.vue?vue&type=template&id=04ec2baa"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "04ec2baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04ec2baa', script)) {
    api.reload('04ec2baa', script)
  }
  
  module.hot.accept("./Map.vue?vue&type=template&id=04ec2baa", () => {
    api.rerender('04ec2baa', render)
  })

}

script.__file = "src/icons/components/filled/Map.vue"

export default script